import { createContext, useContext } from 'react';
import type { logger as ServerLogger } from '@legalzoom/logger';
import type { logger as BrowserLogger } from '@legalzoom/logger/browser-logger';

export type LoggerType = typeof ServerLogger | typeof BrowserLogger;

export const LoggingContext = createContext<{
  logger: LoggerType | null;
  setLogger: (logger: LoggerType) => void;
}>({
  logger: null,
  // TODO: Remove the setLogger function. It's not used anywhere.
  setLogger: () => {},
});

export const useRemixLogger = () => useContext(LoggingContext);
